import { createSelector } from 'reselect';
import isNil from 'lodash/isNil';
import each from 'lodash/each';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import difference from 'lodash/difference';
import { penceToPounds } from '$app/utils/util';
import { LINE_ITEMS_TABLE_DATA, LINE_ITEMS_PRICE_COLUMNS } from '../constants';
import { quoteState } from '../selectors';

export default function collectionDeliverySelector() {
  return createSelector(
    quoteState,
    state => {
      if (!state) return null;
      return state.get('lineItems')
        .filter(li => li.get('type') === 'c&d' && li.get('accountCode') !== '304')
        .toJS()
        .map(cd => pickBy(
          cd,
          (val, key) =>
            !isNil(val) &&
            difference(LINE_ITEMS_TABLE_DATA, [
              'subLineItems',
              'labourTime',
              'labourCost',
              'partsQuantity',
              'partsPrice',
            ]).includes(key))
        ).map(li => {
          const { operationId, workSummary, title, source, status } = li;
          Object.assign(li, {
            key: operationId,
            workOperation: {
              value: source,
              text: workSummary || title,
            },
            className: ['collection-delivery-row', 'footer-row', status === 'deleted' && 'status-deleted'],
          });
          each(pick(li, LINE_ITEMS_PRICE_COLUMNS), (v, k) => (li[k] = penceToPounds(v)));
          return li;
        })
    }
  );
}
